import React from 'react';
import { iconPairs } from '../data.js';

export function ProgressBar({ completedProducts, unlockedSlots, onProductClick, isModalOpen }) {
    const slots = [];
    for (let i = 0; i < 10; i++) {
        const isUnlocked = unlockedSlots.includes(i);
        const product = iconPairs[i];
        
        slots.push(
            <div 
                key={i}
                className={`keyhole ${isUnlocked ? 'active' : ''}`}
                data-slot={i.toString()}
                onClick={() => {
                    if (isUnlocked && product && onProductClick) {
                        onProductClick(product);
                    }
                }}
                style={isUnlocked ? { cursor: 'pointer' } : {}}
            >
                <div 
                    className="keyhole-icon"
                    style={isUnlocked && product ? {
                        backgroundImage: `url('./images/SVG/${product.productIcon}.svg')`,
                        backgroundSize: '60%',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    } : {}}
                >
                </div>
            </div>
        );
    }
    
    return (
        <div className="progress-container">
            <div className="progress-title">
                DISCOVERED PRODUCTS: <span className="progress-score-text">
                    {completedProducts.toString().padStart(2, '0')}/10
                </span>
            </div>
            <div className="keyhole-slots">
                {slots}
            </div>
        </div>
    );
}
